import { Star as StarIcon } from "../Icon/Star";
import { cx } from "class-variance-authority";
import * as styles from "./PromoIcon.module.scss";

export const PromoIcon = ({ className }: { className?: string }) => (
  <StarIcon className={cx(styles.promoIcon, className)} />
);
